import { useFetch } from "@hyper-fetch/react";

import { getRepositories } from "api";
import { Container, Description, Link, MainText, SecondaryText, Title } from "components";
import { Card } from "./card/card";

import styles from "./projects.module.css";

const command = getRepositories.setParams({ account: "BetterTyped" }).setQueryParams({ per_page: 20 });

// Prefetching
command.send();

export const Projects: React.FC = () => {
  const { data } = useFetch(command);
  const repositories = [...(data ?? [])].sort((a, b) => b.stargazers_count - a.stargazers_count).slice(0, 6);

  return (
    <Container className={styles.container}>
      <Title className={styles.title}>
        <MainText slide="left">We Create and Challenge</MainText>
      </Title>
      <Description className={styles.description}>
        <SecondaryText slide="right">
          Here is what we have created so far and which we are extremely proud of.
        </SecondaryText>
      </Description>
      <div className={styles.row}>
        {repositories.map((repository, index) => (
          <SecondaryText key={repository.id} slide="top" delay={index * 200}>
            <Card repository={repository} />
          </SecondaryText>
        ))}
      </div>
      <SecondaryText slide="right">
        <Link href="https://github.com/BetterTyped" target="blank" className={styles.link}>
          See more projects
        </Link>
      </SecondaryText>
    </Container>
  );
};
